import { article, articleListingSection } from '@stereoagency/sanity-schema';
import { TaxonomyType } from '@stereoagency/constants';
import { $globalSanityClient } from '@/sanity';
import { articlesQuery } from './articlesQuery';
import UIArticleListingSection from './ArticleListingSection.client';
import { fetchTaxonomyCounts, fetchTotalCount } from '@/fetchers';

type Props = typeof articleListingSection.schema.articleListingSection;

export default async function ArticleListingSection({
  enableTaxonomyFilter
}: Props) {
  const [totalCount, totalCounts, articles] = await Promise.all([
    fetchTotalCount(article.schema.document.name),
    fetchTaxonomyCounts(
      [TaxonomyType.NEWS_CATEGORY],
      [article.schema.document.name]
    ),
    $globalSanityClient.fetch<(typeof articlesQuery)[1]>(articlesQuery[0])
  ]);

  return (
    <UIArticleListingSection
      enableTaxonomyFilter={enableTaxonomyFilter}
      articles={articles}
      totalCount={totalCount}
      taxonomyCounts={Object.fromEntries(totalCounts.entries())}
    />
  );
}
